<template>
  <div class="node-player-div">
    <canvas v-if="isMobile" key="not-isFullScreen" id="node-video" style="width: 100%;height: 100%;background:#000;" />
    <canvas
      v-else
      key="not-isFullScreen-pc"
      id="node-video"
      height="960"
      width="1920"
      :style="{
        width: '100%',
        display: 'flex',
        alignItems: 'center'
      }"
    />
    <div class="player-btn" v-if="!isFullScreen" @click.self="handleShowBtn">
      <div
        v-if="loading"
        style="height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;"
      >
        <cube-loading class="loading" v-if="tip === '课程即将开始，请稍等'"></cube-loading>
        <span v-else>{{ tip }}</span>
      </div>
      <img
        v-show="isStop"
        src="@/assets/play.png"
        style="
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 10%;"
        @click.self="startPlayer"
      />
      <div class="player-btn-bottom" v-show="showBnt">
        <img src="@/assets/fullScreen.png" @click.self="handleFullScreen(true)" />
      </div>
    </div>
    <div
      class="player-btn-isFullScreen"
      v-else
      :style="{ height: `${screenHeight}px` }"
      @click.self="handleShowBtn"
    >
      <img
        v-show="isStop"
        src="@/assets/play.png"
        style="
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%) rotate(90deg);"
        @click.self="startPlayer"
      />
      <div class="player-btn-left" v-show="showBnt">
        <img src="@/assets/notFullScreen.png" @click.self="handleFullScreen(false)" />
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/utils/index.js';

export default {
  name: 'm-player',
  props: {
    src: {
      type: String,
      required: true
    },
    live: {
      type: Boolean,
      default: false
    },
    liveStatus: {
      type: Number,
      required: false,
      default: 0
    },
    end: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      url: '',
      isFullScreen: false,
      currentIndex: 0,
      urls: [],
      showBnt: false,
      loading: false,
      startWidth: 0,
      startHeight: 0,
      screenHeight: 0,
      screenWidth: 0,
      isStop: false,
      isMobile: false
    };
  },
  computed: {
    tipText() {
      return this.end ? '课程已结束, 谢谢观看' : '课程即将开始，请稍等';
    },
    tip() {
      let tip2048 = this.tipText;
      if (this.liveStatus === 2) {
        tip2048 = '请等待直播开始';
      } else if (this.liveStatus === 1) {
        tip2048 = '直播已结束';
      }
      return tip2048;
    }
  },
  created() {
    if (this.src) {
      this.urls = this.src.split(',');
      if (this.urls[0] === '') {
        this.urls.shift();
      }
      this.url = this.urls[0];
    }
    this.isMobile = isMobile();
    console.log('this.isMobile', this.isMobile);
  },
  mounted() {
    this.width = document.documentElement.clientWidth;
    this.height = (this.width * 9) / 16;
    this.contentHeight = document.documentElement.clientHeight - this.height - 48 - 46;

    this.screenWidth = window.screen.availWidth;
    // this.screenHeight = window.screen.availHeight;
    // this.screenHeight =
    //   document.getElementsByClassName('player')[0].clientHeight +
    //   document.getElementsByClassName('comments')[0].clientHeight + 48;

    setTimeout(() => {
      this.screenHeight =
        document.getElementsByClassName('player')[0].clientHeight +
        document.getElementsByClassName('comments')[0].clientHeight + 48;
    }, 500);
    // var updateOrientation = function() {
    //   var orientation = window.orientation;

    //   switch(orientation) {
    //     case 90: case -90:
    //       orientation = 'landscape';
    //     break;
    //     default:
    //       orientation = 'portrait';
    //   }
    //   document.body.parentNode.setAttribute('class', orientation);
    // };
    // // event triggered every 90 degrees of rotation
    // window.addEventListener('orientationchange', updateOrientation, false);

    ['fullscreenchange','webkitfullscreenchange','mozfullscreenchange'].forEach((item) => {
      window.addEventListener(item, (event) => {
        if (document.fullscreenElement) {
        } else {
          this.handleFullScreen(false)
        }
      });
    })

    // document.addEventListener("fullscreenchange", (event) => {
    //   if (document.fullscreenElement) {
    //     this.handleFullScreen(false)
    //   } else {
    //   }
    // });
    // this.screenHeight =
    //   document.getElementsByClassName('player')[0].clientHeight +
    //   document.getElementsByClassName('comments')[0].clientHeight +
    //   document.getElementsByClassName('apply')[0].clientHeight;
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.handleFullScreen(false);
        this.stopPlayer();
      }
    });
    this.initPlayer();
  },
  methods: {
    handleShowBtn() {
      this.showBnt = !this.showBnt;
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.showBnt = false;
      }, 3000);
    },
    handleFullScreen(flag) {
      if (flag) {
        this.isFullScreen = true;
        this.player.resizeView(this.screenWidth, this.screenHeight);
        setTimeout(() => {
          this.player.onResize(90);
          this.$emit('onFullScreen', true);
          this.$forceUpdate();
          // var self = document.getElementsByTagName('body')[0];
          // 全屏
          // var rfs = self.requestFullScreen || self.webkitRequestFullScreen || self.mozRequestFullScreen || self.msRequestFullScreen,
          //   wscript
          // if (typeof rfs != "undefined" && rfs) {
          //   rfs.call(self);
          //   return;
          // };
          // if (typeof window.ActiveXObject != "undefined") {
          //   wscript = new ActiveXObject("WScript.Shell");
          //   if (wscript) {
          //       wscript.SendKeys("{F11}");
          //   };
          // };
          // if (this.isStop === true) {
          //   this.player.clearView();
          // }
        }, 100);
      } else {
        this.isFullScreen = false;
        this.player.resizeView(this.startWidth, this.startHeight);
        setTimeout(() => {
          this.player.onResize(0);
          this.$emit('onFullScreen', false);
          this.$forceUpdate();
          // 退出全屏
          // var el = document,
          //   cfs = el.cancelFullScreen || el.webkitCancelFullScreen || el.mozCancelFullScreen || el.exitFullScreen, wscript;
          // if (typeof cfs != "undefined" && cfs) {
          //   cfs.call(el);
          //   return;
          // }
          // if (typeof window.ActiveXObject != "undefined") {
          //   wscript = new ActiveXObject("WScript.Shell");
          //   if (wscript != null) {
          //     wscript.SendKeys("{F11}");
          //   }
          // }
        }, 0);
      }
    },
    initPlayer() {
      if (this.player) {
        this.player.release();
      }
      this.loading = true;
      // eslint-disable-next-line no-undef
      this.player = new NodePlayer();
      this.player.setBufferTime(500);
      // this.player.setVolume(0.6);
      this.player.setView('node-video');
      // if (!this.isMobile) {
      this.player.setScaleMode(1);
      // }

      const cvs = document.getElementsByClassName('node-player-div');
      this.startHeight = cvs[0].clientHeight;
      this.startWidth = cvs[0].clientWidth;

      this.player.on('start', () => {
        console.log('player on start');
        this.loading = false;
      });
      this.player.on('stats', s => {
        console.log('player on stats===', s);
      });
      this.player.on('error', e => {
        console.log('player on error===', e);
        if (this.live) {
          this.$emit('onError');
        }
        this.initPlayer();
      });
      this.player.on('videoInfo', (w, h) => {
        console.log(`player on video info width=${w} height=${h}`);
      });
      // this.player.start(this.url.replace(/m3u8/, 'flv'));
      // setTimeout(() => {
      //   this.stopPlayer();
      // }, 1500);
      this.loading = false;
      this.isStop = true;
    },
    startPlayer() {
      if (this.player) {
        this.player.start(this.url.replace(/m3u8/, 'flv'));
        // 上层用户操作来触发音频恢复
        this.player.audioResume();
        this.isStop = false;
      }
    },
    stopPlayer() {
      this.player.stop();
      this.isStop = true;
    },
    play() {
      if (this.live) {
        this.liveStatus === 0 && this.player && this.player.play();
      } else {
        this.player && this.player.play();
      }
    },
    pause() {
      this.player && this.player.pause();
    },
    playVideo(url, index) {
      if (this.player) {
        this.player.load(url);
        this.currentIndex = index;
      }
    }
  },
  watch: {
    src(val) {
      this.url = val;
      this.initPlayer();
    }
  },
  destroyed() {
    this.player.release();
    this.player = null;
  }
};
</script>

<style lang="less">
.node-player-div {
  width: 100%;
  height: 100%;
  position: relative;

  .player-btn-isFullScreen {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 999;
    color: #fff;

    .player-btn-left {
      height: 100%;
      width: 36px;
      z-index: 999;
      background-color: rgba(0, 0, 0, 0.4);
      position: relative;

      img {
        position: absolute;
        bottom: 32px;
        left: 6px;
        height: 24px;
        width: 24px;
      }
    }
  }

  .player-btn {
    position: absolute;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 999;
    color: #fff;
    text-align: right;
    line-height: 50px;

    .player-btn-bottom {
      position: absolute;
      bottom: 0;
      height: 36px;
      width: 100%;
      z-index: 999;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      text-align: right;
      line-height: 50px;

      img {
        margin-right: 12px;
        margin-bottom: 2px;
      }
    }
  }
}
.portrait body div { width: 10%; }
.landscape body div { width: 15%; }
</style>
